import * as React from 'react';
import { ComplexValue } from 'ui';
import { SimpleFormComponentProps, ApiToUse, SerializeType } from 'app/infrastructure/simple-form/types';
import { FIELD_TYPE } from 'app/infrastructure/simple-form/field-types';
import { manageOptionsUserGroup } from 'app/area/shared/manage-options';
import { clearValidationFactory } from 'app/area/administration/shared/helpers';
import { ClearValidation } from 'app/area/administration/shared/types';

export interface MainUserGroupProps {
  fieldName: string;
  labelText: string;
  initialValue: ComplexValue<number>;
  readOnly: boolean;
  optionsEndpoint: string;
  optionsParams?: any;
  editMode: boolean;
  translation: any;
  formComponent: React.ComponentType<SimpleFormComponentProps>;
  clearValidation: ClearValidation;
}

export const UserGroup = (props: MainUserGroupProps) => {

  const {
    fieldName, readOnly, labelText, optionsEndpoint, optionsParams, initialValue,
    formComponent: SimpleForm, translation, editMode, clearValidation
  } = props;

  return <SimpleForm
    name={fieldName}
    type={FIELD_TYPE.SELECT_SINGLE_HIERARCHY}
    optionsEndpoint={optionsEndpoint}
    optionsParams={optionsParams}
    apiToUse={ApiToUse.ADMINAPI}
    placeholder={translation.search}
    translation={translation}
    label={{ text: labelText, required: editMode }}
    initialValue={initialValue}
    descriptionAllLevels={true}
    serialize={{ type: SerializeType.V_VALUE }}
    readOnly={readOnly}
    extraFooterButton={manageOptionsUserGroup(translation.manage_options)}
    clearServerValidation={clearValidationFactory(fieldName, clearValidation)}
  />;
};
